/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Empty } from '../../models/empty';

export interface CouponsAutoApplyCouponIdDelete$Params {
  'Active-Tenant-Identifier': string;
  couponId: string;
}

export function couponsAutoApplyCouponIdDelete(http: HttpClient, rootUrl: string, params: CouponsAutoApplyCouponIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Empty>> {
  const rb = new RequestBuilder(rootUrl, couponsAutoApplyCouponIdDelete.PATH, 'delete');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('couponId', params.couponId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Empty>;
    })
  );
}

couponsAutoApplyCouponIdDelete.PATH = '/coupons/auto-apply/{couponId}';
